import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  InjectionToken,
  input,
  signal,
} from '@angular/core';
import { DividerModule } from '@openng/optimus-ui/divider';

export const CORE_ORG_PRODUCT_LOGO = new InjectionToken<string>('ProductLogo', {
  providedIn: 'root',
  factory: () => '/assets/svg/VIGIL_WHITE-White.svg',
});

@Component({
  selector: 'core-org-product-logo',
  imports: [CommonModule, DividerModule],
  template: `
    <div class="flex items-center justify-center w-full h-full">
      @let orgLogoUrl = orgLogo();
      @let productLogoUrl = resolvedProductLogo();
      @if (orgLogoUrl) {
        <img
          [src]="orgLogoUrl"
          alt="org logo"
          data-testid="org-logo"
          class="w-full h-full"
          (load)="orgLogoLoaded.set(true)"
        />
        @if (orgLogoLoaded()) {
          <div class="flex items-center h-2/5 -mt-1">
            <p-divider layout="vertical" class="mx-2 h-full" />
          </div>
        }
      }
      <img
        [src]="productLogoUrl"
        [ngClass]="orgLogoUrl ? 'h-2/5' : 'h-full'"
        data-testid="product-logo"
        alt="product logo"
        class="w-full"
      />
    </div>
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgProductLogoComponent {
  public orgLogo = input<string>();
  public productLogo = input<string>();
  private readonly injectedProductLogo = inject(CORE_ORG_PRODUCT_LOGO);
  protected resolvedProductLogo = computed(
    () => this.productLogo() ?? this.injectedProductLogo,
  );
  protected orgLogoLoaded = signal(false);
}
